import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=74b07d83&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=ts"
export * from "./Pagination.vue?vue&type=script&lang=ts"
import style0 from "./Pagination.vue?vue&type=style&index=0&id=74b07d83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b07d83",
  null
  
)

export default component.exports